import { render, staticRenderFns } from "./CardMensalista.vue?vue&type=template&id=35b7128d&scoped=true&"
import script from "./CardMensalista.vue?vue&type=script&lang=ts&"
export * from "./CardMensalista.vue?vue&type=script&lang=ts&"
import style0 from "./CardMensalista.vue?vue&type=style&index=0&id=35b7128d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b7128d",
  null
  
)

export default component.exports